// extracted by mini-css-extract-plugin
export default {"person":"c6f1a23bbdd1f2d0","personName":"_9c2cc4dc446e20a7"};